import { PaginationResult } from '@/models/pagination.model';
import {
  BaseService,
  Status,
  DataResponse,
  MessageResponse,
  MessageData,
} from './base.service';
import { Goal } from '@/models/goal.model';

class GoalsService extends BaseService {
  private url: string = '/api/goal';

  constructor() {
    super();
  }

  public async create(item: Goal): Promise<DataResponse<Goal>> {
    const res = await this.$http.post<Goal>(this.url, item);

    return {
      status: [Status.Ok, Status.Created].includes(res.status),
      data: res.data,
    };
  }

  public async update(item: Goal): Promise<DataResponse<Goal>> {
    const res = await this.$http.put<Goal>(`${this.url}/${item.id}`, item);

    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async publish(
    id: number,
    published: boolean,
  ): Promise<DataResponse<Goal>> {
    const res = await this.$http.put<Goal>(`${this.url}/publish`, {
      id,
      published,
    });

    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async get(id: number): Promise<DataResponse<Goal>> {
    const res = await this.$http.get<Goal>(`${this.url}/${id}`);
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async getList(): Promise<DataResponse<PaginationResult<Goal>>> {
    const res = await this.$http.get<PaginationResult<Goal>>(`${this.url}`);
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async delete(id: number): Promise<MessageResponse> {
    const res = await this.$http.delete<MessageData>(`${this.url}/${id}`);

    return {
      status: res.status === Status.Ok,
      message: res.data.message,
    };
  }
}

export default new GoalsService();
